import initialstate from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import {isApiResponseOk} from '../../util/utils';
import {HttpStatusCodes} from '../../util/uiconstants';

export function stEntityReducer(state = initialstate.stentities, action) {
	switch (action.type) {
		case types.ALL_STENTITIES: {
			if (action.response) {
				return action.response || state;
			}
			break;
		}
		case types.DELETE_STENTITY: {
			if (isApiResponseOk(action) || action.error.response.status === HttpStatusCodes.NotFound) {
				return {
					...state,
					data: state?.data?.filter((stentity) => stentity.id !== action.stentityId)
				};
			}
			break;
		}
		case types.CREATE_STENTITY: {
			if (action.response) {
				const existingData = _.cloneDeep(state.data ?? []);
				return {
					...state,
					data: [...existingData, action.response]
				};
			}
			break;
		}
		case types.ALL_STENTITIES_FOR_TASK: {
			if (isApiResponseOk(action)) {
				return {...state, ...action.response};
			}
			break;
		}
		default:
			return state;
	}
}

export function taskSTEntityReducer(state = initialstate.taskstentities, action) {
	switch (action.type) {
		case types.ALL_STENTITIES_FOR_TASK: {
			if (isApiResponseOk(action)) {
				return action.response || state;
			}
			break;
		}
		default:
			return state;
	}
}
